<template>
  <div class="filter-region-country">
    <div>
      <FeldLabel class="mb-2" :icon="Globe" :text="$t('REISEN.COMMON.KONTINENT')" />
      <AppSelect
        :title="$t('REISEN.COMMON.KONTINENT')"
        :label="$t('REISEN.COMMON.KONTINENT')"
        :options="optionsRegions"
        :value="selectedRegion"
        :state="selectedRegion.length > 0 ? true : null"
        group-label="group"
        group-values="continents"
        text-field="label"
        multiple
        @input="onInputFormSelect('inputRegion', $event || [])"
      />
    </div>
    <div>
      <FeldLabel class="mb-2" :icon="Flag" :text="$t('REISEN.COMMON.COUNTRY')" />
      <AppSelect
        :title="$t('REISEN.COMMON.COUNTRY')"
        :label="$t('REISEN.COMMON.COUNTRY')"
        :options="optionsCountries"
        :value="selectedCountry"
        :state="selectedCountry.length > 0 ? true : null"
        text-field="label"
        multiple
        @input="onInputFormSelect('inputCountry', $event || [])"
      />
    </div>
  </div>
</template>

<script>
import AppSelect from '@/components/common/app-select/app-select.vue';
import FeldLabel from '@/components/common/feld-label.vue';
import { Globe, Flag } from 'lucide-vue';
import { reiseCountryName } from '@/core/common/iso3166Countries.js';

export default {
  components: {
    AppSelect,
    FeldLabel,
  },
  props: {
    valueRegion: { type: Array, default: () => [] },
    valueCountry: { type: Array, default: () => [] },
    countriesGroupedByRegions: { type: Object, default: () => {} },
  },
  data() {
    return {
      Globe,
      Flag,
      regionsCountriesObj: null,
    };
  },
  computed: {
    selectedRegion() {
      return Array.isArray(this.valueRegion) && this.valueRegion.length > 0 ? this.valueRegion : [];
    },
    selectedCountry() {
      return Array.isArray(this.valueCountry) && this.valueCountry.length > 0 ? this.valueCountry : [];
    },
    optionsRegions() {
      return this.regionsCountriesObj || [];
    },
    // Ohne gewählte Region stehen alle Länder zur Auswahl, sonst nur die der gewählten Kontinente
    optionsCountries() {
      if (!this.regionsCountriesObj) {
        return [];
      }
      const kontinente = this.regionsCountriesObj.flatMap(group => group.continents);
      const relevanteKontinente = this.selectedRegion.length
        ? kontinente.filter(continent => this.selectedRegion.includes(continent.value))
        : kontinente;
      const alleLaender = relevanteKontinente.flatMap(continent => continent.countries);
      // Ein Land kann in mehreren Regionen liegen, daher distinct nach value
      const eindeutigeLaender = [...new Map(alleLaender.map(land => [land.value, land])).values()];
      return this.sortCountriesArray(eindeutigeLaender);
    },
  },
  watch: {
    countriesGroupedByRegions: {
      immediate: true,
      handler: async function (v) {
        if (v) {
          this.regionsCountriesObj = this.sortRegionArray(this.convertRegionObjectToArray(v));
        }
      },
    },
  },
  methods: {
    onInputFormSelect(eventType, $event) {
      // Reset country filter if region is selected
      if (eventType === 'inputRegion') {
        this.$emit('inputCountry', []);
      }
      this.$emit(eventType, $event);
    },
    convertRegionObjectToArray(groupedRegionObject) {
      // converts the grouped object into a grouped array of objects
      // and groups them by the indices of groupObj into Fernreisen or Europa
      // translates values to labels
      // Input: { Region1 : { countries: []}, Region2: {}, ...}
      // Output: [ {group: "Fernreisen", continents : { label: Region1, value: Region1, countries: []},{value: Region2,label: Region2, countries: []}}]
      const groupObj = {
        Asien: 0,
        Orient: 0,
        Amerika: 0,
        Afrika: 0,
        Ozeanien: 0,
        Dach: 1,
        Südeuropa: 1,
        Nordeuropa: 1,
      };
      let regionArray = Object.entries(groupedRegionObject);
      return regionArray.reduce(
        (accumulator, [region, countries]) => {
          const groupIndex =
            groupObj[region] !== null && groupObj[region] !== undefined ? groupObj[region] : 3;
          accumulator[groupIndex].continents.push({
            value: region,
            label: this.$t(`REISEN.REGIONS.${region}`),
            countries: countries.map(country => {
              return {
                value: country.country,
                label: reiseCountryName(country.country),
              };
            }),
          });
          return accumulator;
        },
        [
          { group: 'Fernreisen', continents: [] },
          { group: 'Europareisen', continents: [] },
        ]
      );
    },
    sortRegionArray(array) {
      // Sorts they array according to the specified order array
      const orderArray = [
        'Asien',
        'Orient',
        'Afrika',
        'Amerika',
        'Ozeanien',
        'Dach',
        'Südeuropa',
        'Nordeuropa',
      ];
      return array.sort((a, b) => {
        const index1 = orderArray.indexOf(a.value);
        const index2 = orderArray.indexOf(b.value);
        return (index1 > -1 ? index1 : Infinity) - (index2 > -1 ? index2 : Infinity);
      });
    },
    sortCountriesArray(array) {
      // Sorts the countries by their labels
      return array.sort((a, b) => a.label.localeCompare(b.label));
    },
  },
};
</script>

<style scoped>
.filter-region-country {
  display: flex;
  gap: 12px;
}
.filter-region-country > * {
  flex: 1;
  min-width: 0;
}
</style>
